import React from 'react';

const OnlineShopping = () => {
  const categories = [
    {
      id: 1,
      name: 'Electronics',
      items: ['Smartphones', 'Laptops', 'Tablets', 'Accessories'],
      image: '📱',
      color: '#007bff'
    },
    {
      id: 2,
      name: 'Fashion',
      items: ["Men's Clothing", "Women's Clothing", 'Shoes', 'Accessories'],
      image: '👔',
      color: '#e91e63'
    },
    {
      id: 3,
      name: 'Home & Garden',
      items: ['Furniture', 'Decor', 'Kitchen', 'Garden Tools'],
      image: '🏠',
      color: '#4caf50'
    },
    {
      id: 4,
      name: 'Sports & Outdoors',
      items: ['Fitness Equipment', 'Outdoor Gear', 'Sports Clothing', 'Accessories'],
      image: '⚽',
      color: '#ff9800'
    },
    {
      id: 5,
      name: 'Books & Media',
      items: ['Books', 'Movies', 'Music', 'Games'],
      image: '📚',
      color: '#9c27b0'
    },
    {
      id: 6,
      name: 'Groceries',
      items: ['Fresh Produce', 'Dairy', 'Bakery', 'Beverages'],
      image: '🛒',
      color: '#8bc34a'
    }
  ];

  const featuredProducts = [
    {
      id: 1,
      name: 'Wireless Headphones',
      price: '$49.99',
      category: 'Electronics',
      rating: '⭐⭐⭐⭐⭐'
    },
    {
      id: 2,
      name: 'Smart Watch',
      price: '$199.99',
      category: 'Electronics',
      rating: '⭐⭐⭐⭐'
    },
    {
      id: 3,
      name: 'Running Shoes',
      price: '$79.99',
      category: 'Sports',
      rating: '⭐⭐⭐⭐⭐'
    },
    {
      id: 4,
      name: 'Coffee Maker',
      price: '$89.99',
      category: 'Home',
      rating: '⭐⭐⭐⭐'
    }
  ];

  const handleCategoryClick = (category) => {
    alert(`Browsing ${category} - This would show products in ${category}`);
  };

  const handleProductClick = (product) => {
    alert(`Viewing ${product.name} - This would show product details`);
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>XGO Online Shopping</h1>
        <p style={styles.subtitle}>Shop thousands of products from the comfort of your home</p>
      </div>

      <div style={styles.searchSection}>
        <input 
          type="text" 
          placeholder="Search for products..."
          style={styles.searchInput}
        />
        <button style={styles.searchButton}>Search</button>
      </div>

      <div style={styles.categoriesSection}>
        <h2 style={styles.sectionTitle}>Shop by Category</h2>
        <div style={styles.categoryGrid}>
          {categories.map(category => (
            <div 
              key={category.id} 
              style={{...styles.categoryCard, borderColor: category.color}}
              onClick={() => handleCategoryClick(category.name)}
            >
              <div style={styles.categoryImage}>{category.image}</div>
              <h3 style={styles.categoryName}>{category.name}</h3>
              <p style={styles.categoryItems}>{category.items.length} items</p>
            </div>
          ))}
        </div>
      </div>

      <div style={styles.featuredSection}>
        <h2 style={styles.sectionTitle}>Featured Products</h2>
        <div style={styles.productGrid}>
          {featuredProducts.map(product => (
            <div 
              key={product.id} 
              style={styles.productCard}
              onClick={() => handleProductClick(product)}
            >
              <div style={styles.productImage}>📦</div>
              <h3 style={styles.productName}>{product.name}</h3>
              <p style={styles.productPrice}>{product.price}</p>
              <p style={styles.productRating}>{product.rating}</p>
              <button style={styles.addToCartButton}>Add to Cart</button>
            </div>
          ))}
        </div>
      </div>

      <div style={styles.servicesSection}>
        <h2 style={styles.sectionTitle}>Our Services</h2>
        <div style={styles.servicesGrid}>
          <div style={styles.service}>
            <h3>🚚 Fast Delivery</h3>
            <p>Same-day delivery available in major cities</p>
          </div>
          <div style={styles.service}>
            <h3>💳 Secure Payment</h3>
            <p>Multiple payment options with bank-level security</p>
          </div>
          <div style={styles.service}>
            <h3>↩️ Easy Returns</h3>
            <p>30-day return policy on most items</p>
          </div>
          <div style={styles.service}>
            <h3>📞 24/7 Support</h3>
            <p>Round-the-clock customer service</p>
          </div>
        </div>
      </div>

      <div style={styles.newsletterSection}>
        <h2 style={styles.sectionTitle}>Stay Updated</h2>
        <p>Subscribe to our newsletter for exclusive deals and updates</p>
        <div style={styles.newsletterForm}>
          <input 
            type="email" 
            placeholder="Enter your email"
            style={styles.emailInput}
          />
          <button style={styles.subscribeButton}>Subscribe</button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    fontFamily: 'Arial, sans-serif',
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '20px',
    backgroundColor: '#f8f9fa'
  },
  header: {
    textAlign: 'center',
    marginBottom: '40px',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: 'white',
    padding: '40px',
    borderRadius: '10px'
  },
  title: {
    fontSize: '2.5rem',
    margin: '0',
    marginBottom: '10px'
  },
  subtitle: {
    fontSize: '1.2rem',
    margin: '0',
    opacity: 0.9
  },
  searchSection: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '40px',
    gap: '10px'
  },
  searchInput: {
    padding: '12px 20px',
    fontSize: '1rem',
    border: '2px solid #ddd',
    borderRadius: '25px',
    width: '300px',
    outline: 'none'
  },
  searchButton: {
    padding: '12px 30px',
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    borderRadius: '25px',
    cursor: 'pointer',
    fontSize: '1rem'
  },
  sectionTitle: {
    textAlign: 'center',
    fontSize: '2rem',
    marginBottom: '30px',
    color: '#333'
  },
  categoriesSection: {
    marginBottom: '50px'
  },
  categoryGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '20px'
  },
  categoryCard: {
    backgroundColor: 'white',
    padding: '25px',
    borderRadius: '10px',
    textAlign: 'center',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    cursor: 'pointer',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    border: '3px solid transparent'
  },
  categoryImage: {
    fontSize: '3rem',
    marginBottom: '15px'
  },
  categoryName: {
    fontSize: '1.3rem',
    margin: '0 0 10px 0',
    color: '#333'
  },
  categoryItems: {
    color: '#666',
    margin: '0'
  },
  featuredSection: {
    marginBottom: '50px'
  },
  productGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '20px'
  },
  productCard: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '10px',
    textAlign: 'center',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    cursor: 'pointer',
    transition: 'transform 0.3s ease'
  },
  productImage: {
    fontSize: '3rem',
    marginBottom: '15px'
  },
  productName: {
    fontSize: '1.2rem',
    margin: '0 0 10px 0',
    color: '#333'
  },
  productPrice: {
    fontSize: '1.1rem',
    color: '#007bff',
    fontWeight: 'bold',
    margin: '0 0 5px 0'
  },
  productRating: {
    margin: '0 0 15px 0',
    fontSize: '0.9rem'
  },
  addToCartButton: {
    backgroundColor: '#28a745',
    color: 'white',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '0.9rem'
  },
  servicesSection: {
    marginBottom: '50px'
  },
  servicesGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '20px'
  },
  service: {
    backgroundColor: 'white',
    padding: '25px',
    borderRadius: '10px',
    textAlign: 'center',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
  },
  newsletterSection: {
    backgroundColor: 'white',
    padding: '40px',
    borderRadius: '10px',
    textAlign: 'center',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    marginBottom: '40px'
  },
  newsletterForm: {
    display: 'flex',
    justifyContent: 'center',
    gap: '10px',
    marginTop: '20px'
  },
  emailInput: {
    padding: '12px 20px',
    fontSize: '1rem',
    border: '2px solid #ddd',
    borderRadius: '5px',
    width: '250px',
    outline: 'none'
  },
  subscribeButton: {
    padding: '12px 30px',
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '1rem'
  }
};

export default OnlineShopping;
